<template>
  <div class="main-container">
    <div class="image-wrapper">
      <v-img
        :src="require(`@/assets/home/banner-img.png`)"
        alt="Banner Image"
        class="main-img"
      ></v-img>
      <div class="overlay"></div>
      <div class="logo-img">
        <img :src="require(`@/assets/header/logo.png`)" alt="Logo"><br>
      </div>
      <div class="scroll-btn">
        <img
          :src="require(`@/assets/home/scroll-down.png`)"
          class="scroll-icon"
          alt="scroll image"
          @click="handleClick"
        >
        <h4>Scroll Down</h4>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineEmits } from 'vue';

const emit = defineEmits(['scroll-to-section']);

function handleClick() {
  emit('scroll-to-section');
}
</script>

<style scoped>
.main-container {
  position: relative;
  z-index: 20;
  margin-top: -64px;
}
.image-wrapper {
  position: relative;
}
.main-img {
  display: block;
  width: 100%;
  height: 100vh;
}
.main-img >>> .v-img__img--contain{
  object-fit: fill !important;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to left, rgba(201, 210, 218, 0.7), rgba(171, 204, 236, 0.7));
}
.logo-img {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.logo-img img {
  height: 320px;
}
.scroll-btn{
  position: absolute;
  top: 85%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  cursor: pointer;
  transition: opacity 0.6s;
}
.scroll-btn:hover{
  opacity: 0.6;
}
.scroll-icon{
  width: 46px;
  height: 51px;
  margin-bottom: 12px;
}
.scroll-btn h4{
  font-style: italic;
  font-size: 16px;
}
@media (max-width: 1300px) {
  .scroll-icon{
    width: 38px;
    height: 40px;
    margin-bottom: 10px;
  }
  .scroll-btn h4{
    font-size: 14px;
  }
  .logo-img img {
    height: 260px;
  }
  .main-container {
    margin-top: -48px;
  }
}
@media (max-width: 1100px) {
  .scroll-icon{
    width: 34px;
    height: 37px;
    margin-bottom: 8px;
  }
  .scroll-btn h4{
    font-size: 12px;
  }
  .logo-img img {
    height: 230px;
  }
  .main-container {
    margin-top: -32px;
  }
}
@media (max-width: 850px) {
  .scroll-icon{
    width: 30px;
    height: 34px;
    margin-bottom: 6px;
  }
  .scroll-btn h4{
    font-size: 10px;
  }
  .logo-img img {
    height: 200px;
  }
  .main-container {
    margin-top: -16px;
  }
}
@media (max-width: 650px) {
  .scroll-icon{
    width: 26px;
    height: 31px;
    margin-bottom: 4px;
  }
  .logo-img img {
    height: 170px;
  }
  .main-container {
    margin-top: 0px;
  }
}
</style>